var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentsMenuIconV4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66664 2.96296C2.33936 2.96296 2.07405 3.22828 2.07405 3.55556V12.1481C2.07405 12.1481 2.07405 12.1481 2.07405 12.1481C2.07405 12.3067 2.1363 12.4507 2.23768 12.557C2.25008 12.57 2.26307 12.5825 2.2766 12.5943C2.38082 12.6855 2.51728 12.7407 2.66664 12.7407H12.1481C12.2981 12.7407 12.4351 12.685 12.5395 12.5931C12.576 12.5611 12.6085 12.5245 12.6364 12.4841C12.677 12.4252 12.7072 12.3586 12.7244 12.2869L14.2027 6.66933C14.2495 6.49161 14.2111 6.30226 14.0989 6.15672C13.9867 6.01118 13.8134 5.92593 13.6296 5.92593H12.7407V4.74074C12.7407 4.41346 12.4754 4.14815 12.1481 4.14815H7.06025L6.04863 3.13653C5.9375 3.0254 5.78677 2.96296 5.62961 2.96296H2.66664ZM11.5555 5.92593V5.33333H6.81479C6.65763 5.33333 6.5069 5.2709 6.39577 5.15977L5.38415 4.14815H3.25924V7.5678L3.57505 6.36771C3.64356 6.10737 3.87893 5.92593 4.14813 5.92593H11.5555ZM3.43536 11.5556H11.6913L12.8609 7.11111H4.60495L3.43536 11.5556Z",
    fill: "#45455A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentsMenuIconV4);
export default __webpack_public_path__ + "static/media/documents-menu-icon-v4.ceca35da98b436c3f1be9593ed4385a6.svg";
export { ForwardRef as ReactComponent };